import { render, staticRenderFns } from "./payDalog2.vue?vue&type=template&id=996a106e&scoped=true&"
import script from "./payDalog2.vue?vue&type=script&lang=js&"
export * from "./payDalog2.vue?vue&type=script&lang=js&"
import style0 from "./payDalog2.vue?vue&type=style&index=0&id=996a106e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996a106e",
  null
  
)

export default component.exports